import { render, staticRenderFns } from "./EditNewMeritSubGroup.html?vue&type=template&id=63193962&external"
import script from "./EditNewMeritSubGroup.ts?vue&type=script&lang=ts&external"
export * from "./EditNewMeritSubGroup.ts?vue&type=script&lang=ts&external"
import style0 from "./EditNewMeritSubGroup.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports